export const maskCardNumber = (value: string): string => {
    return 'X'.repeat(value.length - 4) + value.slice(-4);
};
